import Chartist from "chartist";
import $ from "jquery";
import _ from "lodash";
import chart from "../../chart";

const Chart = {
  /**
   * Parse hidden input for details on lang splits.
   * @return {object|null}
   */
  getLangSplitsData() {
    const $input = $('input[name="langSplits"]');
    if (!$input.length) {
      return null;
    }

    const langSplits = JSON.parse($input.val());
    const data = {
      series: [],
      labels: [],
    };

    _.each(langSplits, (percentage, lang) => {
      const number = percentage.split("%")[0];
      data.series.push(parseInt(number, 10));
      data.labels.push(`${percentage} ${lang}`);
    });
    return data;
  },

  /**
   */
  init() {
    const langSplitsData = this.getLangSplitsData();
    if (!_.isNull(langSplitsData)) {
      chart.renderPieChart(langSplitsData, ".lang-splits-chart-target");
    }
  },
};
export default Chart;
